export const showLoading = (text = '') => ({
  type: 'SHOW_LOADING',
  data: text,
});

export const hideLoading = (text = '') => ({
  type: 'HIDE_LOADING',
  data: text,
});

